import { useState, useEffect } from "react";
import { CONFIG, goToCheckout } from "../../config";
import { Flame, Timer, X } from "lucide-react";
import { useI18n } from "../../i18n";

function useCountdown(mins) {
  const [s, setS] = useState(mins * 60);
  useEffect(() => {
    const saved = parseInt(sessionStorage.getItem("cd") || "0", 10);
    if (saved > 0) setS(saved);
    const id = setInterval(() => {
      setS((v) => {
        const nv = v > 0 ? v - 1 : mins * 60;
        sessionStorage.setItem("cd", String(nv));
        return nv;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [mins]);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

export default function AnnouncementBar() {
  const time = useCountdown(CONFIG.COUNTDOWN_MINUTES);
  const { t, currency, fmtCcy } = useI18n();
  const [closed, setClosed] = useState(false);
  const save = fmtCcy(currency.mrp - currency.price);
  if (closed) return null;
  return (
    <div data-testid="announcement-bar"
      className="relative w-full text-[11px] sm:text-[13px] font-mono text-center py-2 px-4"
      style={{ background: "linear-gradient(90deg,#8a6a15 0%,#e7b43b 50%,#8a6a15 100%)", color: "#1a1200" }}>
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 sm:gap-4 flex-wrap pr-8">
        <span className="inline-flex items-center gap-1.5 font-bold uppercase tracking-wider">
          <Flame className="w-3 h-3 sm:w-3.5 sm:h-3.5" /> {t("ann_launch_offer")}
        </span>
        <span className="hidden sm:inline">·</span>
        <span className="hidden sm:inline">{t("ann_save_today", { amount: save })}</span>
        <span className="hidden sm:inline">·</span>
        <span className="inline-flex items-center gap-1.5">
          <Timer className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
          <span className="font-bold tabular-nums">{time}</span>
        </span>
        <button onClick={() => goToCheckout(currency.code, currency.price)}
          className="hidden md:inline-flex ml-1 px-3 py-1 rounded-full bg-[#1a1200] text-[#f5d06a] text-[11px] font-bold uppercase tracking-wider hover:bg-black">
          {t("ann_grab")}
        </button>
      </div>
      <button onClick={() => setClosed(true)} aria-label="Close"
        className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 grid place-items-center rounded-full hover:bg-black/10">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
